import { useDispatch, useSelector } from "react-redux"
import { setOpenAddArticleED } from "../../Reducer/ModalSlice"
import { useEffect, useState } from "react"
import { IoClose } from "react-icons/io5"
import { changeCommentAddedArticle, changeDateAddedArticle, changeSumAddedArticle, clearAddedArticle, selectAddedArticle } from "../../Reducer/AddArticleInARSlice"
import axios from "axios"
import { addAdeddArticle } from "../../Reducer/AdvanceReprotsSlice"

function AddArticleED(){
    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const AddedArticle = useSelector(state => state.AddArticleInARSlice.AddedArticle)
    const EditAddedArticle = useSelector(state => state.AddArticleInARSlice.EditAddedArticle)
    const AddAdminArticle = useSelector(state => state.AddArticleInARSlice.AddAdminArticle)
    const AddAdminOtherExpenditure = useSelector(state => state.AddArticleInARSlice.AddAdminOtherExpenditure)

    const Article = useSelector(state => state.ArticleSlice.Article)

    const AdvanceReportED = useSelector(state => state.AdvanceReprotsSlice.AdvanceReportED)

    const [CancelTouch, setCancelTouch] = useState(false)
    const [VisibleType, setVisibleType] = useState('')
    const [VisibleTransactionType, setVisibleTransactionType] = useState('')
    const [SearchingArticle, setSearchingArticle] = useState()
    const [ArticleArray, setArticleArray] = useState()
    const [openSearchArticle, setOpenSearchArticle] = useState(false)
    const [VisibleDate, setVisibleDate] = useState('')
    const [DatePeriod, setDatePeriod] = useState({Min: 0, Max: 1})
    const [isLoadingSave, setLoadingSave] = useState(true)
    const [OpenDeletedModal, setOpenDeletedModal] = useState(false)

    const dispatch = useDispatch()
    
    const getDatePeriod = () => {
        const MinDay = AdvanceReportED.YearValue + '-' + String(AdvanceReportED.MonthValue).padStart(2, '0') + '-01'
        let MaxDay = ''

        if(AdvanceReportED.MonthValue === 1 || AdvanceReportED.MonthValue === 3 || AdvanceReportED.MonthValue === 5 || AdvanceReportED.MonthValue === 7 || AdvanceReportED.MonthValue === 8 || AdvanceReportED.MonthValue === 10 || AdvanceReportED.MonthValue === 12)
            MaxDay = AdvanceReportED.YearValue + '-' + String(AdvanceReportED.MonthValue).padStart(2, '0') + '-31'

        if(AdvanceReportED.MonthValue === 2)
            if(AdvanceReportED.YearValue % 4 === 0 && (AdvanceReportED.YearValue % 100 !== 0 || AdvanceReportED.YearValue % 400 === 0)) 
            {
                MaxDay = AdvanceReportED.YearValue + '-' + String(AdvanceReportED.MonthValue).padStart(2, '0') +  '-29'
            }
            else
            {
                MaxDay = AdvanceReportED.YearValue + '-' + String(AdvanceReportED.MonthValue).padStart(2, '0') + '-28'
            }
        
        if(AdvanceReportED.MonthValue === 4 || AdvanceReportED.MonthValue === 6 || AdvanceReportED.MonthValue === 9 || AdvanceReportED.MonthValue === 11 )
            MaxDay = AdvanceReportED.YearValue + '-' + String(AdvanceReportED.MonthValue).padStart(2, '0') + '-30'    

        setDatePeriod({Min: MinDay, Max: MaxDay})
    }

    const setVisible = () => {
        if(!AddAdminOtherExpenditure)
        {
            if(AddedArticle.Type === 'income')
            {
                setVisibleType('Доход')            
                if(AddedArticle.TransactionType === 'Cash')
                {
                    setVisibleTransactionType('Наличные')
                    setArticleArray(Article.Income.filter((el) => 
                        el.TransactionType === 'Cash' || el.TransactionType === 'All'
                    ))
                    setSearchingArticle(Article.Income.filter((el) => 
                        el.TransactionType === 'Cash' || el.TransactionType === 'All'
                    ))
                }
                if(AddedArticle.TransactionType === 'NonCash')
                {
                    setVisibleTransactionType('Без наличные')
                    setArticleArray(Article.Income.filter((el) => 
                        el.TransactionType === 'NonCash' || el.TransactionType === 'All'
                    ))
                    setSearchingArticle(Article.Income.filter((el) => 
                        el.TransactionType === 'NonCash' || el.TransactionType === 'All'
                    ))
                }
            }

            if(AddedArticle.Type === 'expenditure')
            {
                setVisibleType('Расход')        
                if(AddedArticle.TransactionType === 'Cash')
                {
                    setVisibleTransactionType('Наличные')
                    setArticleArray(Article.Expenditure.filter((el) => 
                        el.TransactionType === 'Cash' || el.TransactionType === 'All'                      
                    ))
                    setSearchingArticle(Article.Expenditure.filter((el) => 
                        el.TransactionType === 'Cash' || el.TransactionType === 'All'                        
                    ))
                }
                if(AddedArticle.TransactionType === 'NonCash')
                {
                    setVisibleTransactionType('Без наличные')
                    setArticleArray(Article.Expenditure.filter((el) => 
                        el.TransactionType === 'NonCash' || el.TransactionType === 'All'
                    ))
                    setSearchingArticle(Article.Expenditure.filter((el) => 
                        el.TransactionType === 'NonCash' || el.TransactionType === 'All'
                    ))
                }
            }

            if(AddedArticle.Type === 'collection')
            {
                setVisibleType('Инкассация')
                setSearchingArticle(Article.Collection)
                setArticleArray(Article.Collection)
                setVisibleTransactionType('Наличные')
            }     
        }
        
        if(AddAdminOtherExpenditure)
        {
            if(AddedArticle.Type === 'income')
                {
                    setVisibleType('Доход')            
                    if(AddedArticle.TransactionType === 'Cash')
                    {
                        setVisibleTransactionType('Наличные')
                        setArticleArray(Article.Income.filter((el) => 
                            (el.TransactionType === 'Cash' || el.TransactionType === 'All') && el.OtherExpenditure
                        ))
                        setSearchingArticle(Article.Income.filter((el) => 
                            (el.TransactionType === 'Cash' || el.TransactionType === 'All') && el.OtherExpenditure
                        ))
                    }
                    if(AddedArticle.TransactionType === 'NonCash')
                    {
                        setVisibleTransactionType('Без наличные')
                        setArticleArray(Article.Income.filter((el) => 
                            (el.TransactionType === 'NonCash' || el.TransactionType === 'All') && el.OtherExpenditure
                        ))
                        setSearchingArticle(Article.Income.filter((el) => 
                            (el.TransactionType === 'NonCash' || el.TransactionType === 'All') && el.OtherExpenditure
                        ))
                    }
                }
        
                if(AddedArticle.Type === 'expenditure')
                {
                    setVisibleType('Расход')        
                    if(AddedArticle.TransactionType === 'Cash')
                    {
                        setVisibleTransactionType('Наличные')
                        setArticleArray(Article.Expenditure.filter((el) => 
                            (el.TransactionType === 'Cash' || el.TransactionType === 'All') && el.OtherExpenditure                  
                        ))
                        setSearchingArticle(Article.Expenditure.filter((el) => 
                            (el.TransactionType === 'Cash' || el.TransactionType === 'All') && el.OtherExpenditure                        
                        ))
                    }
                    if(AddedArticle.TransactionType === 'NonCash')
                    {
                        setVisibleTransactionType('Без наличные')
                        setArticleArray(Article.Expenditure.filter((el) => 
                            (el.TransactionType === 'NonCash' || el.TransactionType === 'All') && el.OtherExpenditure  
                        ))
                        setSearchingArticle(Article.Expenditure.filter((el) => 
                            (el.TransactionType === 'NonCash' || el.TransactionType === 'All') && el.OtherExpenditure  
                        ))
                    }
                }
        }

        setVisibleDate(AddedArticle.CreateAdDate)
    }

    const handleClickSaveButton = async () => {
        setLoadingSave(false)
        let SaveArray = []        
        let ErrorCheck = 0
        if(AddedArticle.idArticle === 0)
        {
            ErrorCheck = ErrorCheck + 1
            alert('Не указана статья')
        }

        if(!AddedArticle.Sum)
        {
            ErrorCheck = ErrorCheck + 1
            alert('Не указана сумма')
        }

        if(!AddedArticle.CreateAdDate)
        {
            ErrorCheck = ErrorCheck + 1
            alert('Не указана дата')
        }

        if(ErrorCheck === 0 && !AddAdminArticle && !AddAdminOtherExpenditure)
        {                            
                await AdvanceReportED.Articles.map((el) => {
                    SaveArray.push(el)
                    return(el)
                })

            if(EditAddedArticle)
                SaveArray = await SaveArray.filter((el) => el.id !== AddedArticle.id)

            await SaveArray.push({
                id: parseInt(AddedArticle.id),
                Sum: parseFloat(AddedArticle.Sum),
                Name: AddedArticle.Name,
                ResponsibleUserName: AddedArticle.ResponsibleUserName,
                OtherExpenditure: AddedArticle.OtherExpenditure,
                TransactionType: AddedArticle.TransactionType,
                Type: AddedArticle.Type,
                idArticle: AddedArticle.idArticle,
                Comment: AddedArticle.Comment,
                CreateAd: String(AddedArticle.CreateAdDate + 'T' + AddedArticle.CreateAdTime)
            })

            if(EditAddedArticle)
                SaveArray = await SaveArray.sort((a , b) => {
                    return a.id - b.id
                })
            
            await axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                Articles: SaveArray,
              }, {
                headers: {
                  Authorization: 'Bearer ' + User.jwt,
                },
              })
            .then(async () => {
                await dispatch(addAdeddArticle(SaveArray))         
                dispatch(setOpenAddArticleED(false))
                dispatch(clearAddedArticle())                        
            })
            .catch(() => {
                alert('Не удалось сохранить данные, повторите попытку')
            })                                
        }

        if(ErrorCheck === 0 && (AddAdminArticle || AddAdminOtherExpenditure))
        {
            let AdvanceReportChek = ''
            await axios.get(Server + 'cityadvancereports?_limit=-1', {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                },
                params:{
                    idCity: AddedArticle.idCity,
                    MonthValue: parseFloat(new Date(AddedArticle.CreateAdDate).getMonth() + 1),
                    YearValue: parseFloat(new Date(AddedArticle.CreateAdDate).getFullYear())
                }
            })
            .then((response) => {
                AdvanceReportChek = response.data[0]
            })

            SaveArray = []

            let CommentChek = ''
                if(AddedArticle.Comment)
                    CommentChek = AddedArticle.Comment

            await AdvanceReportChek.AdminArticles.map((el) => {
                SaveArray.push(el)
                return(el)
            })                
                
            if(!EditAddedArticle)
            {
                let ChekId = 1
                if(AdvanceReportChek.AdminArticles.length > 0)
                    ChekId = parseInt(AdvanceReportChek.AdminArticles[AdvanceReportChek.AdminArticles.length - 1].id + 1)
                await SaveArray.push({
                    id: ChekId,
                    Sum: parseFloat(AddedArticle.Sum),
                    Name: AddedArticle.Name,
                    ResponsibleUserName: AddedArticle.ResponsibleUserName,
                    OtherExpenditure: AddedArticle.OtherExpenditure,
                    TransactionType: AddedArticle.TransactionType,
                    Type: AddedArticle.Type,
                    idArticle: AddedArticle.idArticle,
                    Comment: CommentChek,
                    CreateAd: String(AddedArticle.CreateAdDate + 'T' + AddedArticle.CreateAdTime)
                })
            }
            else
            {
                SaveArray = await SaveArray.filter((el) => el.id !== AddedArticle.id)
                await SaveArray.push({
                    id: AddedArticle.id,
                    Sum: parseFloat(AddedArticle.Sum),
                    Name: AddedArticle.Name,
                    ResponsibleUserName: AddedArticle.ResponsibleUserName,
                    OtherExpenditure: AddedArticle.OtherExpenditure,
                    TransactionType: AddedArticle.TransactionType,
                    Type: AddedArticle.Type,
                    idArticle: AddedArticle.idArticle,
                    Comment: CommentChek,
                    CreateAd: String(AddedArticle.CreateAdDate + 'T' + AddedArticle.CreateAdTime)
                })

                SaveArray = await SaveArray.sort((a , b) => {
                    return a.id - b.id
                })    
            }                        

            await axios.put(Server + 'cityadvancereports/' + AdvanceReportChek.id, {
                AdminArticles: SaveArray,
              }, {
                headers: {
                  Authorization: 'Bearer ' + User.jwt,
                },
              })
            .then(async () => {       
                dispatch(setOpenAddArticleED(false))
                dispatch(clearAddedArticle())                        
            })
            .catch(() => {
                alert('Не удалось сохранить данные, повторите попытку')
            })                                
        }
        setLoadingSave(true)
    }

    const handleClickDeleteButton = async () => {
        setLoadingSave(false)
        let SaveArray = []        
        
        if(!AddAdminArticle && !AddAdminOtherExpenditure)
        {    
            await AdvanceReportED.Articles.map((el) => {
                SaveArray.push(el)
                return(el)
            })

            SaveArray = await SaveArray.filter((el) => el.id !== AddedArticle.id)

            SaveArray = await SaveArray.sort((a , b) => {
                return a.id - b.id
            })
            
            await axios.put(Server + 'cityadvancereports/' + AdvanceReportED.id, {
                Articles: SaveArray,
                }, {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                },
                })
            .then(async () => {
                await dispatch(addAdeddArticle(SaveArray))         
                dispatch(setOpenAddArticleED(false))
                setOpenDeletedModal(false)
                dispatch(clearAddedArticle())                        
            })
            .catch(() => {
                alert('Не удалось удалить данные, повторите попытку')
        })                     
        }
        else
        {
            let AdvanceReportChek = ''
            await axios.get(Server + 'cityadvancereports?_limit=-1', {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                },
                params:{
                    idCity: AddedArticle.idCity,
                    MonthValue: parseFloat(new Date(AddedArticle.CreateAdDate).getMonth() + 1),
                    YearValue: parseFloat(new Date(AddedArticle.CreateAdDate).getFullYear())
                }
            })
            .then((response) => {
                AdvanceReportChek = response.data[0]
            })

            SaveArray = []

            await AdvanceReportChek.AdminArticles.map((el) => {
                SaveArray.push(el)
                return(el)
            })        

            SaveArray = await SaveArray.filter((el) => el.id !== AddedArticle.id)

            SaveArray = await SaveArray.sort((a , b) => {
                return a.id - b.id
            })    

            await axios.put(Server + 'cityadvancereports/' + AdvanceReportChek.id, {
                AdminArticles: SaveArray,
              }, {
                headers: {
                  Authorization: 'Bearer ' + User.jwt,
                },
              })
            .then(async () => {       
                dispatch(setOpenAddArticleED(false))
                dispatch(clearAddedArticle())                        
            })
            .catch(() => {
                alert('Не удалось удалить данные, повторите попытку')
            })     
        }           
        
        setLoadingSave(true)
    }

    useEffect(() => {
        setVisible()
        if(!AddAdminArticle)
            getDatePeriod()
        // eslint-disable-next-line
    }, [AddedArticle, Article])

    if(!isLoadingSave)
        return(
        <div
        className="AddArticleEDGlobalDiv"
        >
                <div
                className="BigSpin ArticleAdd"
                />
        </div>
    )
    
    return(
        <div
        className="AddArticleEDGlobalDiv"
        onClick={(() => {
            setOpenSearchArticle(false)
            document.getElementById('Input SearchArticle').value = document.getElementById('Input SearchArticle').defaultValue
            document.getElementById('CashInputAR Sum').blur()
            document.getElementById('CashInputAR Comment').blur()
            document.getElementById('InputDate AddArticle').blur()
        })}
        onTouchStart={() => {
            setCancelTouch(false)
        }}
        onTouchMove={() => {
            setCancelTouch(true)
        }}
        onTouchCancel={() => {
            setCancelTouch(true)
        }}
        onTouchEnd={((event) => {
            event.preventDefault()  
            if(!CancelTouch)
            {
                setOpenSearchArticle(false)
                document.getElementById('Input SearchArticle').value = document.getElementById('Input SearchArticle').defaultValue
                document.getElementById('CashInputAR Sum').blur()
                document.getElementById('CashInputAR Comment').blur()
                document.getElementById('InputDate AddArticle').blur()
                document.getElementById('Input SearchArticle').blur()  
            }
        })}
        >
            <div
            className="AddArticleEDMainDiv"
            >
                <div
                className="CloseAddArticleEDButtonDiv"
                >
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() => {
                        dispatch(setOpenAddArticleED(false))
                        dispatch(clearAddedArticle())                        
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()  
                        if(!CancelTouch)
                        {
                            dispatch(setOpenAddArticleED(false))
                            dispatch(clearAddedArticle())
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>
                <div
                className="AddArticleEDInformationDiv"
                >
                    <div
                    className={"AddArticleEDInformation " + AddedArticle.Type}
                    >
                        {VisibleType}
                    </div>
                    <div
                    className="AddArticleEDInformation"
                    >
                        {VisibleTransactionType}
                    </div>
                </div>
                <div
                className="AddArticleEDInputDiv"
                >
                    <div
                    className="AddArticleEDInputText"
                    >
                        Дата:
                    </div>
                    <input
                    className="DateInputAddArticle"
                    id='InputDate AddArticle'
                    defaultValue={VisibleDate}
                    type="date"
                    min={DatePeriod.Min}
                    max={DatePeriod.Max}
                    onChange={((e) => {
                        setVisibleDate(e.target.value)                        
                    })}
                    onBlur={(() => {
                        if(VisibleDate !== AddedArticle.CreateAdDate)
                        {
                            dispatch(changeDateAddedArticle(new Date(VisibleDate).getFullYear() + '-' + String(parseFloat(new Date(VisibleDate).getMonth()) + 1).padStart(2, '0') + '-' + String(new Date(VisibleDate).getDate()).padStart(2, '0')))
                        }
                        document.getElementById('InputDate AddArticle').value =  document.getElementById('InputDate AddArticle').defaultValue
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        if(!CancelTouch)
                        {
                            event.stopPropagation()
                            document.getElementById('InputDate AddArticle').focus()
                        }
                    })}
                    />
                </div>

                <div
                className="AddArticleEDInputDiv"
                >
                    <div
                    className="AddArticleEDInputText"
                    >
                        Статья:
                    </div>
                    <div>
                        <input
                        className="SearchingInputAR AddArticleED"
                        placeholder="Выбор статьи"
                        id='Input SearchArticle'
                        defaultValue={AddedArticle.Name}
                        onClick={((event) => {  
                            if(!AddAdminArticle)  
                            {
                                event.stopPropagation()       
                                setSearchingArticle(ArticleArray)             
                                document.getElementById('Input SearchArticle').value = ''
                            }
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()  
                            if(!CancelTouch && !AddAdminArticle)
                            {
                                event.stopPropagation()
                                setSearchingArticle(ArticleArray)
                                document.getElementById('Input SearchArticle').value = ''      
                                document.getElementById('Input SearchArticle').focus()                          
                            }
                        })}
                        onFocus={(() => {
                            if(AddAdminArticle)
                                return(document.getElementById('Input SearchArticle').blur())
                            setOpenSearchArticle(true)
                        })}
                        onChange={((e) => {
                            if(!AddAdminArticle)
                            {
                                var Val = e.target.value.toLowerCase()
                                setSearchingArticle(ArticleArray.filter((el) => 
                                    el.Name.toLowerCase().includes(Val)
                                ))     
                            }                       
                        })}
                        />
                        {openSearchArticle &&
                        <div
                        className="SearchingARMainDiv"
                        >
                            <div
                            className="SearchingARContainer AddArticleED"                            
                            >
                                {SearchingArticle.map((el) => 
                                <button
                                key={el.id}
                                className="SearchingAROneCity"
                                onClick={(async (event) => {     
                                    event.stopPropagation()                          
                                    await dispatch(selectAddedArticle({Name: el.Name, idArticle: el.id, OtherExpenditure: el.OtherExpenditure}))
                                    document.getElementById('Input SearchArticle').value = document.getElementById('Input SearchArticle').defaultValue
                                    setOpenSearchArticle(false)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(async (event) => {
                                    event.preventDefault()  
                                    if(!CancelTouch)
                                    {
                                        event.stopPropagation()
                                        await dispatch(selectAddedArticle({Name: el.Name, idArticle: el.id, OtherExpenditure: el.OtherExpenditure}))
                                        document.getElementById('Input SearchArticle').value = document.getElementById('Input SearchArticle').defaultValue
                                        setOpenSearchArticle(false)
                                    }
                                })}
                                >
                                    {el.Name}
                                </button>
                                )}
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <div
                className="AddArticleEDInputDiv"
                >
                    <div
                    className="AddArticleEDInputText"
                    >
                        Сумма:
                    </div>
                    <input
                    className="CashInputAR AddArticleED"
                    id="CashInputAR Sum"
                    placeholder="Сумма"
                    value={AddedArticle.Sum}
                    type="number"
                    onClick={((event) => {
                        event.stopPropagation()
                    })}
                    onChange={((e) => {
                        if(e.target.value <= 99999999)
                        {
                            dispatch(changeSumAddedArticle(parseFloat(e.target.value)))
                        }
                        else
                        {
                            dispatch(changeSumAddedArticle(parseFloat(99999999)))
                        }
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()  
                        if(!CancelTouch)
                        {
                            event.stopPropagation()
                            document.getElementById('CashInputAR Sum').focus()
                        }
                    })}
                    />
                </div>

                <div
                className="AddArticleEDInputDiv Comment"
                >
                    <div
                    className="AddArticleEDInputText"
                    >
                        Комментарий:
                    </div>
                    <textarea
                    className="CashInputAR Textarea"
                    id="CashInputAR Comment"
                    placeholder="Комменатрий"
                    value={AddedArticle.Comment}
                    maxLength={100}
                    onClick={((event) => {
                        event.stopPropagation()
                    })} 
                    onChange={((e) => {
                        dispatch(changeCommentAddedArticle(e.target.value))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()  
                        if(!CancelTouch)
                        {
                            event.stopPropagation()
                            document.getElementById('CashInputAR Comment').focus()
                        }
                    })}
                    />
                </div>

                <div
                className="ModalButtonsDiv"
                >
                    <button
                    className="ModalButton Cancle"
                    onClick={(() => {
                        dispatch(setOpenAddArticleED(false))
                        dispatch(clearAddedArticle())
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()  
                        if(!CancelTouch)
                        {
                            dispatch(setOpenAddArticleED(false))
                            dispatch(clearAddedArticle())
                        }
                    })}
                    >
                        Отмена
                    </button>

                    {EditAddedArticle &&
                    <button
                    className="ModalButton Delete"
                    onClick={(() => {
                        setOpenDeletedModal(true)
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()  
                        if(!CancelTouch)                            
                            setOpenDeletedModal(true)                            
                    })}
                    > 
                            Удалить                            
                    </button>
                    }

                    <button
                    className="ModalButton Save"
                    onClick={handleClickSaveButton}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()  
                        if(!CancelTouch)                            
                            handleClickSaveButton()                            
                    })}
                    >
                        Сохранить
                    </button>                        
                </div>
            </div>

            {OpenDeletedModal &&
            <div
            className="AddArticleEDGlobalDiv"
            >
                <div
                className="ModalChangeHiddenMainDiv"
                >
                    <div>
                    {'Подтвердите удаление статьи'}
                    </div>
                    <div
                    className="ModalChangeHiddenButtonsDiv"
                    >
                        <button
                        className="ModalChangeHiddenButton Cancle"
                        onClick={(() => {
                            setOpenDeletedModal(false)
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                setOpenDeletedModal(false)
                        })}
                        >
                            Отмена
                        </button>
                        <button
                        className="ModalChangeHiddenButton Ok"    
                        onClick={handleClickDeleteButton}      
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                handleClickDeleteButton()
                        })}             
                        >
                            Ок
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default AddArticleED